<template>
  <page name="DevicePage">
    <x-nav slot="header">Device</x-nav>
    
    <a :href="'#/inductee/' + inductee.InducteeID">
      <x-now-playing
      text="NOW PLAYING"
      :inductee="inductee"
      ></x-now-playing>
    </a>
    
    <div class="inductee_info">
      <div>Performer: {{ inductee.Performer }}</div>
      <div>Composer: {{ inductee.Composer }}</div>
      <div>Courtesy Of: {{ inductee.CourtesyOf }}</div>
      <div><a class="buy-link" target="_blank" :href="inductee.BuyLink">BUY NOW</a></div>
    </div>
    
    <x-footer slot="footer">
      <a class="button" href="#/inductees">
        <img src="img/addcircle_icon.png" class="button-icon">Explore and Listen</span>
      </a>
    </x-footer>
  </div>
</template>

<script>
export default {
  components: {
    'page': require('./Page.vue'),
    'x-nav': require('./Nav.vue'),
    'x-footer': require('./Footer.vue'),
    'x-now-playing': require('./NowPlaying.vue'),
  },
  computed: {
    inductee () {
      return this.$root.nowPlaying('device')
    }
  }
}
</script>

<style>
  .buy-link,
  .buy-link:visited {
    color: white;
  }
</style>